import { useNavigate } from "react-router-dom";

export const useRedirectPageHelper = () => {
  const navigate = useNavigate();
  
  const redirectTo = (path, arg) => {
    navigate(path, { state: { arg } });
  };
  return redirectTo;
};
